export default {
      id: "ic_new_plus-usage",
      viewBox: "0 0 36 38",
      url: "/" + "images/icons.3.109.2.svg#ic_new_plus-usage",
      toString: function () {
        return this.url;
      }
    }